import { useState } from 'react';

interface ChangePassword {
  email: string;
  password: string;

}

interface MudarSenhaProps {
  changePassword: ({ email, password }: ChangePassword) => void
  email: string
  error?: string
}

export const MudarSenha = ({ changePassword, email, error }: MudarSenhaProps) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [erro, setErro] = useState('')

  function handleMudarSenha() {
    if (password !== confirmPassword) {
      setErro('Senhas precisam ser idênticas.')
      return
    }
    changePassword({ email, password })
  }

  return (
    < div className="m-6" >
      <p className='text-red-600 font-normal text-lg text-center w-full'>{error || erro}</p>
      <form className='flex flex-col items-center my-4' >
        <div className="input-block">
          <p className="input-p text-primary">Digite sua nova senha:</p>
          <input
            type="password"
            className="input-container border-2  text-gray-800"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="input-block">
          <p className="input-p text-primary">Confirme sua senha:</p>
          <input
            type="password"
            className="input-container border-2  text-gray-800"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <button
          type="button"
          className="mt-8 h-11 w-full rounded-lg border-0 bg-primary text-lg font-normal uppercase text-white"
          onClick={() => handleMudarSenha()}
        >Enviar</button>
      </form>

    </div >
  )

}